var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGiftCard({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    "data-name": "Layer 1",
    viewBox: "0 0 24 24",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5,6h-4.23c.193-.132,.376-.28,.545-.448,1.35-1.285,1.576-2.977,.576-4.31-1.028-1.37-2.979-1.648-4.347-.621-1.047,.785-1.664,1.908-2.031,2.897-.366-.989-.984-2.112-2.031-2.897-1.37-1.027-3.32-.749-4.347,.621-1,1.332-.773,3.024,.567,4.301,.172,.172,.36,.322,.556,.457H2.5c-1.378,0-2.5,1.121-2.5,2.5v15.5H24V8.5c0-1.379-1.122-2.5-2.5-2.5ZM14.643,1.422c.93-.697,2.251-.508,2.948,.42,.696,.929,.522,2.045-.475,2.994-.907,.907-2.452,1.121-3.358,1.164h-1.258v-.41c.086-.628,.523-2.953,2.143-4.168Zm-7.743,3.405c-.988-.94-1.162-2.057-.466-2.985,.696-.929,2.019-1.118,2.948-.42,1.574,1.179,2.015,3.403,2.118,4.106v.472h-1.282c-.9-.044-2.406-.261-3.318-1.173ZM2.5,7H11.45c-.504,2.95-5.398,3-5.45,3v1c1.782,0,4.816-.597,6-2.614,1.184,2.018,4.218,2.614,6,2.614v-1c-.052,0-4.946-.05-5.45-3h8.95c.827,0,1.5,.673,1.5,1.5v9.5H1V8.5c0-.827,.673-1.5,1.5-1.5ZM1,23v-4H23v4H1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGiftCard);
export default __webpack_public_path__ + "static/media/gift-card.0a878b6b26659780c0b6d62928c486de.svg";
export { ForwardRef as ReactComponent };